<template>
  <BCard>
    <!-- Media -->
    <BMedia class="mb-2">
        <template #aside>
            <BAvatar ref="previewEl" :src="'/images/avatars/'+user.avatar" :text="avatarText(user.fullName)" size="90px" rounded />
        </template>

        <h4 class="mb-1"> {{ user.name + " " + user.surname }} </h4>
        <h5 class="mb-1" v-if="user.username != '' "> @{{ user.username }} </h5>
    </BMedia>

    <!-- User Info: Input Fields -->
    <ValidationObserver ref="form" #default="{invalid}">
      <BForm @submit.prevent="onSubmit">
        <BRow>
          <TextInputValidated vsName="Username" :vsModel.sync="user.username" vsLabel="username" vsMd="4"  />
          <TextInputValidated vsName="Name" :vsModel.sync="user.name" vsLabel="name" vsMd="4" vsRequired vsRules="required" />
          <TextInputValidated vsName="Surname" :vsModel.sync="user.surname" vsLabel="surname" vsMd="4" vsRequired vsRules="required" />
          <TextInputValidated vsName="Email" :vsModel.sync="user.email" vsLabel="email" vsMd="4" vsRequired vsRules="required|email" />
          <VSelectValidated vsName="Status" :vsModel.sync="user.status" :vsOptions="statusOptions" vsLabel="label" vsMd="4" vsRequired vsRules="required" :vsReduce="status => status.value" />
          <VSelectValidated vsName="User role" :vsModel.sync="user.role" :vsOptions="roles" vsLabel="name" vsMd="4" vsRequired vsRules="required" v-if="roles" />
          <VSelectValidated vsName="Groups" :vsModel.sync="user.groups" :vsOptions="groups" vsLabel="name" vsMd="4" vsMultiple v-if="groups && groups.length>1"/>
          <BCol md="4">
            <ValidationProvider #default="validationContext" name="Contraseña" rules="required">
                <BFormGroup label="Contraseña" label-for="password" class="required-field">
                    <BInputGroup>
                        <BInputGroupPrepend>
                            <BButton variant="outline-primary" @click="generateRandomPassword" >
                              <FeatherIcon icon="KeyIcon" />
                            </BButton>
                        </BInputGroupPrepend>
                        <BFormInput id="password" :type="passwordType" v-model="user.password"/>
                        <BInputGroupAppend is-text>
                          <FeatherIcon :icon="changePasswordIcon" class="cursor-pointer" @click="changePasswordType" />
                        </BInputGroupAppend>
                    </BInputGroup>
                    <BFormInvalidFeedback :state="getValidationState(validationContext)"> {{validationContext.errors[0]}} </BFormInvalidFeedback>
                </BFormGroup>
            </ValidationProvider>
          </BCol>
        </BRow>

      <!-- Action Buttons -->
      <BButton variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="onSubmit"> {{ $t("Save Changes") }} </BButton>
      <BButton variant="outline-secondary" type="reset" :to="{ name:'users' }" :block="$store.getters['app/currentBreakPoint'] === 'xs'"> {{$t('Cancel')}} </BButton>
    </BForm>
  </ValidationObserver>

  </BCard>
</template>

<script>
import { BButton, BMedia, BAvatar, BRow, BCol, BFormGroup, BFormInput, BForm, BTable, BCard, BCardHeader, BCardTitle, BFormCheckbox, BFormInvalidFeedback, BInputGroupAppend, BInputGroup, BInputGroupPrepend } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
import { computed, inject, ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import TextInputValidated from '@/components/forms/TextInputValidated.vue'
import formValidation from '@core/comp-functions/forms/form-validation'
import VSelectValidated from '@/components/forms/vSelectValidated.vue'
import ability from '@/libs/acl/ability'
import popups from '@/hooks/popups'
import vSelect from 'vue-select'
import i18n from '@/libs/i18n'
import store from '@/store'

export default {
  components: { BButton, BMedia, BAvatar, BRow, BCol, BFormGroup, BFormInvalidFeedback, BFormInput, BForm, BTable, BCard, BCardHeader, BCardTitle, BFormCheckbox, vSelect, ValidationProvider, ValidationObserver, TextInputValidated, VSelectValidated, BInputGroupAppend, BInputGroup, BInputGroupPrepend },
    setup(){
        const { getValidationState } = formValidation()
        const { errorToast } = popups()
        const refInputEl = ref(null)
        const previewEl = ref(null)
        const groups = inject('groups')
        const roles = inject('roles')
        const user = inject('user')
        const passwordType = ref('password')

        const statusOptions = [
            { label: i18n.t('Active'), value: 1 },
            { label: i18n.t('Inactive'), value: 0 },
        ]


        // Métodos
        const onSubmit = function(){
            this.$refs.form.validate().then(success => {
                if(success) {
                    store.dispatch('users/addUser', JSON.parse(JSON.stringify(user.value)))
                        .then(response => { 
                          if (response.data.success) {
                            this.$router.push({ name: 'users' })
                          } else {
                            if (response.data.code == 'MAX_USERS_EXCEEDED') {
                              errorToast('No puedes crear más usuarios. Tendrás que mejorar tu plan para ello.')
                            }
                          }
                        })
                        .catch(error => { console.log(error); errorToast('Can\'t add user') })
                }
            })
        }

        const changePasswordType = function() {
            if(passwordType.value == "password"){
                passwordType.value = "text"
            }else{
                passwordType.value = "password"
            }
        }

        const generateRandomPassword = function() {
            user.value.password = Math.random().toString(36).slice(-12);
        }

        // Computados
        const changePasswordIcon = computed(() => {
          return passwordType.value == "password" ? "EyeIcon" : "EyeOffIcon"
        })

        extend('required', required)
        extend('email', email)

        return {
            generateRandomPassword,
            getValidationState,
            changePasswordType,
            changePasswordIcon,
            statusOptions,
            passwordType,
            avatarText,
            refInputEl,
            previewEl,
            onSubmit,
            ability,
            groups,
            roles,
            user
        }
    }
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
  .user-checkbox label::before{ background-color: #0eb7e3 !important; }
  .rol-checkbox label::before { background-color: lightcoral !important;  }
</style>
